import { render, staticRenderFns } from "./RecoveryManagement.vue?vue&type=template&id=95235288&scoped=true"
import script from "./RecoveryManagement.vue?vue&type=script&lang=js"
export * from "./RecoveryManagement.vue?vue&type=script&lang=js"
import style0 from "./RecoveryManagement.vue?vue&type=style&index=0&id=95235288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95235288",
  null
  
)

export default component.exports